"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const styles_1 = require("@material-ui/core/styles");
const core_1 = require("@material-ui/core");
const useStyles = styles_1.makeStyles({
    activityInfo: {
        maxWidth: '100%',
        display: 'flex',
        justifyContent: 'space-between',
        '&:not(:last-child)': {
            marginBottom: '10px'
        }
    },
    title: {
        margin: '0'
    },
    text: {}
});
const ActivityInfo = (props) => {
    const classes = useStyles();
    return (react_1.default.createElement(core_1.Box, { className: `${props.className || ''} ${classes.activityInfo}` },
        react_1.default.createElement("p", { className: classes.title }, props.title),
        react_1.default.createElement("strong", { className: classes.text }, props.text)));
};
exports.default = ActivityInfo;
